import script from "./VACard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VACard.vue?vue&type=script&setup=true&lang=ts"

import "./VACard.vue?vue&type=style&index=0&id=ebd89f96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebd89f96"]])

export default __exports__